import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Config } from "../../config";
import { axiosConfig } from "../../utils/util.fns";
import { Exam } from "../../modal/exam";

export type answers = {
	questionId: number;
	selectedOptionId: number | null;
};
export type examPayload = {
	studentId: number;
	examToken: string;
	questions: answers[];
};

export type failedExamPayload = {
	id: number | null;
	token: tokenPayload;
};

export type saveFailedReasonType = {
	studentId: number;
	reason: string;
};

export type tokenPayload = {
	token: string;
};

export const startExam = createAsyncThunk("start/exam", async (payload: Exam) => {
	const response = await axios.post(Config.apiUrl + "/exam/time", payload, axiosConfig());
	return response.data;
});

export const getAllQuestions = createAsyncThunk("questions/all", async () => {
	const response = await axios.get(Config.apiUrl + "/exam?offset=0&numResults=1000", axiosConfig());
	return response.data;
});

export const getRescheduledQuestions = createAsyncThunk("questions/reschedule", async (studentid: number | null) => {
	const response = await axios.get(
		Config.apiUrl + "/exam?offset=0&numResults=1000&studentId=" + studentid,
		axiosConfig()
	);
	return response.data;
});

export const submitExam = createAsyncThunk("exam/submit", async (payload: examPayload) => {
	const response = await axios.post(Config.apiUrl + "/exam/submit", payload, axiosConfig());
	return response.data;
});

export const draftExam = createAsyncThunk("exam/draft", async (payload: examPayload) => {
	const response = await axios.post(Config.apiUrl + "/exam/autosave", payload, axiosConfig());
	return response.data;
});

export const failedExam = createAsyncThunk("failed/exam", async (payload: failedExamPayload) => {
	const response = await axios.put(Config.apiUrl + `/exam/select/${payload.id}`, payload, axiosConfig());
	return response.data;
});

export const saveFailedReason = createAsyncThunk("failed/reasonSave", async (payload: saveFailedReasonType) => {
	const response = await axios.post(Config.apiUrl + "/exam/disruptions", payload, axiosConfig());
	return response.data;
});
